import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SecurityBasicHttpClientService } from './services/security-basic-http-client.service';
import { BasicHttpClientService } from './services/basic-http-client.service';
import { ODataBasicHttpClientService } from './services/o-data-basic-http-client.service';
import { ApiConfigService } from './services/api-config.service';
import { EnviromentContextService } from '../enviroment/services/enviroment-context-service';
import { ComposeUrlService } from './services/compose-url.service';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule
  ]
})
export class ApiModule {
  static forRoot(server: string, protocol: string): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        SecurityBasicHttpClientService,
        ComposeUrlService,
        { provide: BasicHttpClientService, useClass: ODataBasicHttpClientService },
        { provide: ApiConfigService, useFactory: (enviromentContextService: EnviromentContextService) => {
            return new ApiConfigService(enviromentContextService, server, protocol);
          }, deps: [EnviromentContextService] }
      ]
    };
  }
}
